import React, {useState, useEffect, forwardRef} from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {enGB} from "date-fns/locale";
import {HopnPerks} from "../Components/hopnPerks.jsx";
import {getHopnMinDate, getHopnMaxDate} from "@/utils/filesConstants.js";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {storage, STORAGE_KEYS} from "@/utils/storage";
import {arrowRightWhite} from "@img/index.js";
import {ModalFooter} from "../Components/BookingModalShell.jsx";
import {parseRideDate} from "@/utils/dateUtils.js";

export function TravelingDate({setStep, closeModal}) {
    useEffect(() => {
        if (window.innerWidth < 768) setStep('travelingDateTime');
    }, []);

    const [selectedDay, setSelectedDay] = useState(storage.get(STORAGE_KEYS.RIDE_DATE) ? storage.get(STORAGE_KEYS.RIDE_DATE) : null);
    const [selectedDayCheck, setSelectedDayCheck] = useState(false);

    const CustomInput = forwardRef(({value, onClick}, ref) => (
        <div onClick={onClick} ref={ref} className="hopn-datepicker-input">{value || "Select a date"}</div>
    ));

    return (
        <>
            <ModalHeader title="Select Date and Time" extraClasses="extra-space" totalSteps={3} cancelButton={false} cancelButtonType="text" backStep={storage.get(STORAGE_KEYS.SKIP_LUGGAGE_STEP) === true ? "passengerQuantity" : "passengerLuggage"} showBackButton={true} setStep={setStep} closeModal={closeModal}/>
            <div className="little-title modalPages-spacing"><h2>Select Date</h2></div>
            <div className="hopn-date-info-layout modalPages-spacing">
                <div className="inner-tab">
                    <div className={`hopn-calender-area ${selectedDayCheck && selectedDay === null ? 'hopn-required-error' : ''}`}>
                        <div className="hopn-date-header">
                            <DatePicker
                                selected={parseRideDate(storage.get(STORAGE_KEYS.RIDE_DATE))}
                                onChange={(date) => {
                                    setSelectedDay(date);
                                    storage.set(STORAGE_KEYS.RIDE_DATE, date.toISOString());
                                }}
                                open={true}
                                placeholderText="Select a date"
                                className="hopn-datepicker-input"
                                dateFormat="dd MMM yyyy"
                                minDate={getHopnMinDate()}
                                maxDate={getHopnMaxDate()}
                                showPopperArrow={false}
                                locale={enGB}
                                customInput={<CustomInput/>}
                            />
                        </div>
                    </div>
                </div>
                <div className="inner-tab">
                    <div className="hopn-calender-content">
                        <HopnPerks key="1" sliderOnly modalStyle="popup"/>
                    </div>
                    <ModalFooter>
                        <button className="hopn-add-passenger-button time" onClick={() => {
                            if (selectedDay === null) setSelectedDayCheck(true);
                            else setStep('travelingTime');
                        }}>
                            +Add Time <img decoding="async" src={arrowRightWhite} alt="+ Date & Time"/>
                        </button>
                    </ModalFooter>
                </div>
            </div>
        </>
    );
}
export default TravelingDate;
